import logo from './logo.svg';
import {BrowserRouter, Route, Router, Routes} from 'react-router-dom';
import './App.css';
import Header from './Components/Navbar/Header';
import Home from './Components/Home/Home';
import ContextProvider from './Context/ContextProvider';
import ProductDetail from './Components/Products/ProductDetail';
import Cart from './Components/Cart/Cart';

function App() {
  return (
    <>
      <ContextProvider>
        <BrowserRouter>
          <Header/>
          <Routes>
            <Route path='/' element={<Home/>} />
            <Route path='/product/:id' element={<ProductDetail/>} />
            <Route path='/cart' element={<Cart/>} />
            {/* <Routes path='/' element={<Home/>} /> */}
          </Routes>
        </BrowserRouter>
      </ContextProvider>
    </>
  );
}

export default App;
